import React from "react";
import EditIcon from "@mui/icons-material/Edit";
import ClearIcon from "@mui/icons-material/Clear";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import AddIcon from "@mui/icons-material/Add";
import axios from "axios";
import SweetAlert from "react-bootstrap-sweetalert";
import Pagination from "../../Pagination/Pagination";
import { useAppContext } from "../../Lib/ContextLib";
import { API_URL } from "../../config";
import Loader from "../Loader/Loader";
import EmptyState from "../../Components/EmptyState";

export default function RestrictedArea() {
  const { accessObject } = useAppContext();
  const [alert, setAlert] = React.useState(null);
  const [tableData, setTableData] = React.useState([]);
  const [rowValue, setRowValue] = React.useState();
  const [openValue, setOpenValue] = React.useState(0);
  const [loader, setLoader] = React.useState(false);
  const [showPrePage, setShowPrePage] = React.useState(10);
  const [buttonLoader, setbuttonLoader] = React.useState(false);
  const [showModal, setShowModal] = React.useState(false);
  const [pagination, setPagination] = React.useState({
    start: 0,
    end: showPrePage,
  });

  const onPaginationChange = (start, end) => {
    setPagination({ start: start, end: end });
  };

  const updateShowPerpagevalue = (value) => {
    setShowPrePage(value);
    setPagination({ start: 0, end: value });
  };

  const LoginSchema = Yup.object().shape({
    state: Yup.string().required("State is required"),
    country: Yup.string().required("Country is required"),
    city: Yup.string().required("City is required"),
  });

  React.useEffect(() => {
    getBranch();
  }, []);

  const getBranch = () => {
    setLoader(true);
    axios(`${API_URL}/api/admin/restricted-area/get-restricted-area`, {
      method: "GET",
      credentials: "include",
    })
      .then((response) => {
        setLoader(false);
        setTableData(response.data.data);
      })
      .catch((error) => {
        console.log("getBranch error :::", error);
      });
  };

  const clickEditButton = (item) => {
    setRowValue(item);
    setOpenValue(2);
    setShowModal(true);
  };

  const openAddDialog = () => {
    setRowValue(null);
    setOpenValue(1);
    setShowModal(true);
  };

  const closeModal = () => {
    setShowModal(false);
    setRowValue(null);
  };

  const updateTournament = (value) => {
    axios
      .patch(
        `${API_URL}/api/admin/restricted-area/update-restricted-area/${rowValue._id}`,
        value
      )
      .then((res) => {
        if (res.data.status) {
          setbuttonLoader(false);
          successEdit();
        } else {
          warningAlert();
          setbuttonLoader(false);
        }
      })
      .catch(() => {
        warningAlert();
        setbuttonLoader(false);
      });
  };

  const addNewTournament = (value) => {
    axios(`${API_URL}/api/admin/restricted-area/add-restricted-area`, {
      method: "POST",
      credentials: "include",
      data: value,
    })
      .then((result) => {
        if (result.data.status) {
          setbuttonLoader(false);
          successAdd();
        } else {
          warningAlert();
          setbuttonLoader(false);
        }
      })
      .catch(() => {
        warningAlert();
        setbuttonLoader(false);
      });
  };

  const warningWithConfirmMessage = (e) => {
    setAlert(
      <SweetAlert
        custom
        showCancel
        confirmBtnText="Yes, Delete"
        cancelBtnText="Cancel"
        confirmBtnBsStyle="danger"
        cancelBtnBsStyle="default"
        onConfirm={() => {
          deleteData(e);
          setAlert(null);
        }}
        onCancel={() => setAlert(null)}
        customClass="premium-alert" btnSize="md" title=""
        confirmBtnClass="premium-alert-confirm bg-danger shadow-danger"
        cancelBtnClass="premium-alert-cancel"
        customIcon={<div className="mb-4" style={{ fontSize: "50px", color: "#dc3545" }}><i className="fas fa-trash-alt"></i></div>}
      >
        <div className="premium-alert-title">Are you sure?</div>
        <p className="premium-alert-text">You are about to delete this restricted area record. This action cannot be undone.</p>
      </SweetAlert>
    );
  };

  const deleteData = (e) => {
    axios
      .delete(`${API_URL}/api/admin/restricted-area/delete-restricted-area/${e._id}`)
      .then(() => {
        getBranch();
      });
  };

  const successAdd = () => {
    setAlert(
      <SweetAlert
        success
        style={{ display: "block" }}
        title="Added successfully!"
        onConfirm={() => {
          getBranch();
          setAlert(null);
          closeModal();
        }}
        confirmBtnBsStyle="success"
      >
        Location added successfully...
      </SweetAlert>
    );
  };

  const successEdit = () => {
    setAlert(
      <SweetAlert
        success
        style={{ display: "block" }}
        title="Edited successfully!"
        onConfirm={() => {
          getBranch();
          setAlert(null);
          closeModal();
        }}
        confirmBtnBsStyle="success"
      >
        Location Updated successfully...
      </SweetAlert>
    );
  };

  const warningAlert = () => {
    setAlert(
      <SweetAlert
        warning
        style={{ display: "block" }}
        title="Something Went Wrong!"
        onConfirm={() => setAlert(null)}
        confirmBtnBsStyle="success"
      />
    );
  };

  return (
    <>
      {alert}

      {/* ── Modal Dialog ── */}
      {showModal && (
        <div
          style={{
            position: "fixed", inset: 0, zIndex: 1050,
            background: "rgba(0,0,0,0.45)",
            display: "flex", alignItems: "center", justifyContent: "center",
          }}
          onClick={(e) => { if (e.target === e.currentTarget) closeModal(); }}
        >
          <div
            style={{
              background: "#fff", borderRadius: "16px",
              width: "100%", maxWidth: "520px",
              boxShadow: "0 20px 60px rgba(0,0,0,0.2)",
              overflow: "hidden",
            }}
          >
            {/* Modal Header */}
            <div style={{ padding: "20px 24px", borderBottom: "1px solid #f0f0f0", display: "flex", alignItems: "center", justifyContent: "space-between" }}>
              <h6 style={{ margin: 0, fontWeight: "700", color: "#2d3748", fontSize: "16px" }}>
                {openValue === 1 ? "Add Restricted Area" : "Edit Restricted Area"}
              </h6>
              <button
                onClick={closeModal}
                style={{ background: "none", border: "none", fontSize: "20px", color: "#94a3b8", cursor: "pointer", lineHeight: 1, padding: "4px" }}
              >
                ✕
              </button>
            </div>

            {/* Modal Body */}
            <div style={{ padding: "24px" }}>
              <Formik
                initialValues={{
                  country: rowValue ? rowValue?.country : "",
                  state: rowValue ? rowValue?.state : "",
                  city: rowValue ? rowValue?.city : "",
                }}
                validationSchema={LoginSchema}
                enableReinitialize
                onSubmit={(values) => {
                  setbuttonLoader(true);
                  if (openValue === 1) addNewTournament(values);
                  if (openValue === 2) updateTournament(values);
                }}
              >
                {({ touched, errors }) => (
                  <Form>
                    {/* Country */}
                    <div className="form-group mb-3">
                      <label style={{ fontWeight: "600", color: "#4a5568", fontSize: "13px", marginBottom: "6px", display: "block" }}>
                        Country Name <span className="text-danger">*</span>
                      </label>
                      <Field
                        type="text"
                        name="country"
                        placeholder="Enter Country Name"
                        className={`form-control ${touched.country && errors.country ? "is-invalid" : ""}`}
                        style={{ borderRadius: "8px", border: "1.5px solid #e2e8f0", padding: "10px 14px", fontSize: "14px" }}
                      />
                      <ErrorMessage component="div" name="country" className="invalid-feedback" />
                    </div>

                    {/* State */}
                    <div className="form-group mb-3">
                      <label style={{ fontWeight: "600", color: "#4a5568", fontSize: "13px", marginBottom: "6px", display: "block" }}>
                        State Name <span className="text-danger">*</span>
                      </label>
                      <Field
                        type="text"
                        name="state"
                        placeholder="Enter State Name"
                        className={`form-control ${touched.state && errors.state ? "is-invalid" : ""}`}
                        style={{ borderRadius: "8px", border: "1.5px solid #e2e8f0", padding: "10px 14px", fontSize: "14px" }}
                      />
                      <ErrorMessage component="div" name="state" className="invalid-feedback" />
                    </div>

                    {/* City */}
                    <div className="form-group mb-4">
                      <label style={{ fontWeight: "600", color: "#4a5568", fontSize: "13px", marginBottom: "6px", display: "block" }}>
                        City Name <span className="text-danger">*</span>
                      </label>
                      <Field
                        type="text"
                        name="city"
                        placeholder="Enter City Name"
                        className={`form-control ${touched.city && errors.city ? "is-invalid" : ""}`}
                        style={{ borderRadius: "8px", border: "1.5px solid #e2e8f0", padding: "10px 14px", fontSize: "14px" }}
                      />
                      <ErrorMessage component="div" name="city" className="invalid-feedback" />
                    </div>

                    {/* Buttons */}
                    <div style={{ display: "flex", gap: "10px", paddingTop: "16px", borderTop: "1px solid #f0f0f0", justifyContent: "flex-end" }}>
                      <button
                        type="button"
                        className="btn btn-light"
                        style={{ minWidth: "90px", borderRadius: "8px", fontWeight: "600", padding: "10px 20px", background: "#f1f5f9", border: "none", color: "#475569" }}
                        onClick={closeModal}
                      >
                        Cancel
                      </button>
                      <button
                        type="submit"
                        className="btn btn-primary"
                        style={{ minWidth: "110px", borderRadius: "8px", fontWeight: "700", padding: "10px 20px" }}
                        disabled={buttonLoader}
                      >
                        {buttonLoader ? (
                          <><span className="spinner-border spinner-border-sm mr-2"></span>Saving...</>
                        ) : "Submit"}
                      </button>
                    </div>
                  </Form>
                )}
              </Formik>
            </div>
          </div>
        </div>
      )}

      {/* ── List Page ── */}
      <div className="content p-3">
        <div className="card">
          <div className="card-header bg-white border-bottom-0 pb-0 pt-4 px-4">
            <div className="row align-items-end">
              <div className="col-md-6 mb-3 mb-md-0"></div>
              <div className="col-md-6 text-right">
                {accessObject?.addRestrictedArea === true && (
                  <button
                    onClick={openAddDialog}
                    type="button"
                    className="btn btn-primary"
                  >
                    <AddIcon /> Add New
                  </button>
                )}
              </div>
            </div>
          </div>

          <div className="card-body">
            <table className="table table-bordered table-striped">
              <thead>
                <tr>
                  <th>SrNo</th>
                  <th>Country Name</th>
                  <th>State Name</th>
                  <th>City Name</th>
                  {(accessObject?.editRestrictedArea === true ||
                    accessObject?.deleteRestrictedArea === true) && (
                      <th style={{ textAlign: "center" }}>Action</th>
                    )}
                </tr>
              </thead>
              {accessObject?.getRestrictedArea === true ? (
                <tbody>
                  {!loader ? (
                    <>
                      {tableData.length > 0 ? (
                        <>
                          {tableData
                            ?.slice(pagination.start, pagination.end)
                            .map((item, index) => (
                              <tr key={index}>
                                <td>{index + 1 + pagination.start}</td>
                                <td>{item.country}</td>
                                <td>{item.state}</td>
                                <td>{item.city}</td>
                                {(accessObject?.editRestrictedArea === true ||
                                  accessObject?.deleteRestrictedArea === true) && (
                                    <td>
                                      <div className="d-flex justify-content-evenly">
                                        {accessObject?.editRestrictedArea === true && (
                                          <EditIcon
                                            className="mr-3 courser"
                                            onClick={() => clickEditButton(item)}
                                          />
                                        )}
                                        {accessObject?.deleteRestrictedArea === true && (
                                          <ClearIcon
                                            className="courser text-danger"
                                            onClick={() => warningWithConfirmMessage(item)}
                                          />
                                        )}
                                      </div>
                                    </td>
                                  )}
                              </tr>
                            ))}
                        </>
                      ) : (
                        <EmptyState colSpan={5} />
                      )}
                    </>
                  ) : (
                    <tr><td colSpan={5}><div className="mt-4"><Loader /></div></td></tr>
                  )}
                </tbody>
              ) : (
                <tbody>
                  <tr style={{ backgroundColor: "rgba(0,0,0,.05)" }} className="text-center">
                    <td colSpan={5}><h5>Access Denied</h5></td>
                  </tr>
                </tbody>
              )}
            </table>
          </div>

          {tableData.length !== 0 && (
            <Pagination
              updateShowPerpagevalue={updateShowPerpagevalue}
              showPrePage={showPrePage}
              onPaginationChange={onPaginationChange}
              total={tableData.length}
            />
          )}
        </div>
      </div>
    </>
  );
}
